import { IEditFormForClientManagerState } from './editFormForClientManagerContext';

export enum EditFormForClientManagerActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	TOGGLE_USE_MENU_VERSION = 'TOGGLE_USE_MENU_VERSION',
	TOGGLE_USE_CONTENT_VERSION = 'TOGGLE_USE_CONTENT_VERSION',
	CHANGE_RESTAURANT_MENU_VERSION = 'CHANGE_RESTAURANT_MENU_VERSION',
	CHANGE_RESTAURANT_CONTENT_VERSION = 'CHANGE_RESTAURANT_CONTENT_VERSION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditFormForClientManagerActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditFormForClientManagerState['needRefetchData'];
	};
}

interface ISetInitialFormData {
	type: EditFormForClientManagerActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IEditFormForClientManagerState['initialFormData'];
	};
}

interface ISetAllData {
	type: EditFormForClientManagerActionTypes.SET_ALL_DATA;
	payload: {
		fullRestaurantInfo: IEditFormForClientManagerState['fullRestaurantInfo'];
		useMenuVersion: IEditFormForClientManagerState['useMenuVersion'];
		useContentVersion: IEditFormForClientManagerState['useContentVersion'];
		customerMenuVersion: IEditFormForClientManagerState['customerMenuVersion'];
		customerContentVersion: IEditFormForClientManagerState['customerContentVersion'];
		restaurantMenuVersion: IEditFormForClientManagerState['restaurantMenuVersion'];
		restaurantContentVersion: IEditFormForClientManagerState['restaurantContentVersion'];
	};
}

interface IToggleUseMenuVersion {
	type: EditFormForClientManagerActionTypes.TOGGLE_USE_MENU_VERSION;
	payload: {
		useMenuVersion: IEditFormForClientManagerState['useMenuVersion'];
		restaurantMenuVersion: IEditFormForClientManagerState['restaurantMenuVersion'];
	};
}

interface IToggleUseContentVersion {
	type: EditFormForClientManagerActionTypes.TOGGLE_USE_CONTENT_VERSION;
	payload: {
		useContentVersion: IEditFormForClientManagerState['useContentVersion'];
		restaurantContentVersion: IEditFormForClientManagerState['restaurantContentVersion'];
	};
}

interface IChangeRestaurantMenuVersion {
	type: EditFormForClientManagerActionTypes.CHANGE_RESTAURANT_MENU_VERSION;
	payload: {
		restaurantMenuVersion: IEditFormForClientManagerState['restaurantMenuVersion'];
	};
}

interface IChangeRestaurantContentVersion {
	type: EditFormForClientManagerActionTypes.CHANGE_RESTAURANT_CONTENT_VERSION;
	payload: {
		restaurantContentVersion: IEditFormForClientManagerState['restaurantContentVersion'];
	};
}

interface ISetDataForSubmit {
	type: EditFormForClientManagerActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditFormForClientManagerState['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditFormForClientManagerActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditFormForClientManagerState['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: EditFormForClientManagerActionTypes.RESET_FIELDS;
}

export type TEditFormForClientManagerAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IToggleUseMenuVersion
	| IToggleUseContentVersion
	| IChangeRestaurantMenuVersion
	| IChangeRestaurantContentVersion
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
